import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {
  BillingActionBar,
  BillingLicenseSection,
  BillingQuickStats,
  CreditUsagePanel,
  PriceOverridesTable,
  SuspendOrganizationCard,
} from '../components';
import { useBillingSubscription } from '../hooks';

export const BillingSubscriptionTab: React.FC = () => {
  const billing = useBillingSubscription();

  return (
    <Stack spacing={4}>
      <BillingActionBar
        isSaveDisabled={billing.isSaveDisabled}
        onSave={() => void billing.saveLicense()}
      />

      <BillingQuickStats organizationId={billing.organizationId} />

      <BillingLicenseSection
        catalog={billing.catalog}
        isLicenseActive={billing.isLicenseActive}
        onToggleLicense={billing.toggleLicense}
        licenseStartDate={billing.licenseStartDate}
        licenseEndDate={billing.licenseEndDate}
        onLicenseDateChange={billing.updateLicenseDate}
        monthlyCreditsValue={billing.monthlyCreditsValue}
        onMonthlyCreditsChange={billing.updateMonthlyCredits}
      />

      <CreditUsagePanel usage={billing.usage} />

      <PriceOverridesTable
        overrides={billing.overrides}
        onRemoveOverride={billing.handleRemoveOverride}
      />

      <SuspendOrganizationCard />
    </Stack>
  );
};
